import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import {DatatableViewComponent, RequestParams} from '@ngx-ivengi/crud';
import {ExportationModalService} from '../exportation/exportation-modal.service';
import {Profile} from '../profile/profile.model';
import {ProfileService} from '../profile/profile.service';
import {Datagrid} from './datagrid.model';
import {DatagridService} from './datagrid.service';
import {Observable} from 'rxjs/Observable';
import {UIRouter} from '@uirouter/angular';
import * as _ from 'lodash';
import {EnumerationService} from '../enumeration/enumeration.service';
import {ChannelBulkUpdateModalService} from '../channel/channel-bulk-update-modal.service';
import { ChannelService } from '../channel/channel.service';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { ChannelCurrentState } from '../channel/channel-current-state';

@Component({
  selector: 'app-datagrid-list',
  templateUrl: './datagrid-list.component.html'
})
export class DatagridListComponent extends DatatableViewComponent<Datagrid> implements OnInit, AfterViewInit {

  public selected: any[] = [];
  public editing: any = {};
  public detailEditing: any = {};
  public profile: Profile;

  @Input() public requestParams: RequestParams;
  @Input() public viewMode = false;
  @Input() public searchInitialized: Observable<boolean>;

  public skipToPage: number = null;

  @ViewChild('datagridDatatable') dataTable: any;
  @ViewChild('datasubgridDatatable') subTable: any;

  private bConfigured: boolean = false;
  private datagridService;
  public pageLimitOptions: string[];

  public config = {
    blockWrapper: true,
    throughputSubgrid: {enabled: false, defaultExpanded: false},
    rowSelector: {enabled: false, onSelect: null, onActivate: null, columnHead: null},
    channelSelector: {enabled: false, value: [], onSelect: null},
    exportation: {enabled: false},
    bulkEdit: {enabled: false},
    enabledColumns: [],
    inlineEdit: {},
    onRowChange: null,
    loadProfile: false,
    searchOnInit: true,
  };
  public allSelected = false;
  public loadingSelection = false;

  constructor(
    crudService: DatagridService,
    protected router: UIRouter,
    private exportationModalService: ExportationModalService,
    private channelBulkUpdateModalService: ChannelBulkUpdateModalService,
    private profileService: ProfileService,
    private enumService: EnumerationService,
    private channelService: ChannelService,
  ) {
    super(crudService);
    this.datagridService = crudService;
  }

  public ngOnInit(): void {
    this.rowChange().subscribe((rows: Datagrid[]) => {
      if(this.config.onRowChange && typeof this.config.onRowChange === 'function') {
        this.config.onRowChange(rows, this);
      }
    });

    this.searchInitialized.subscribe((initialized: boolean) => {
      if(initialized && this.config.searchOnInit) {
        this.doFilter();
      }
    });

    if(this.config.loadProfile) {
      this.profileService.get().subscribe((profile) => {
        this.profile = profile;
      });
    }

    this.enumService.get('page-limit-options').subscribe((pageLimitOptions) => {
      this.pageLimitOptions = pageLimitOptions.map(limit => limit.split('PL')[1]);
    });
  }

  public ngAfterViewInit(): void {
    this.rowChange().subscribe(() => {
      forkJoin(
        this.rows
          .filter(row => row.channel.overridden)
          .map(row => this.getCurrentState(row.channel.id as string)),
      ).subscribe((currentChannelData: ChannelCurrentState[]) => {
        if (currentChannelData.length) {
          currentChannelData.forEach((data) => {
            const foundRow = this.rows.find(item => item.channel.id === data.channelId);
            if (foundRow) {
              foundRow.channel.currentState = data;
            }
          });
        }
      });

      if(this.config.throughputSubgrid.defaultExpanded) {
        window.setTimeout(() => {
          this.rows.forEach((row) => {
            if(row.throughputs && row.throughputs.length > 0) {
              this.dataTable.rowDetail.toggleExpandRow(row);
            }
          });
        }, 0);
      }
    });
  }

  public onPageSizeChanged(event) {
    this.requestParams.pagination.limit = event;
    this.requestParams.pagination.offset = 0;
    this.fetchData();
  }

  public doFilter() {
    this.onSelect({selected: []});
    this.filter(null);
  }

  public getRowId(row) {
    row.setId(row.channel.id);
    return row.getId();
  }

  public onClickSelectAll() {
    this.allSelected = !this.allSelected;
    if (this.allSelected) {
      this.loadingSelection = true;
      const rp = _.cloneDeep(this.requestParams);
      rp.pagination.limit = 0;
      this.datagridService.getAll(rp).subscribe((res) => {
        this.onSelect({selected: res});
        this.loadingSelection = false;
        setTimeout(() => {
          // this.dataTable.refresh
          // this.dataTable.recalculateColumns();
          // window.dispatchEvent(new Event('resize'));
        }, 0);
      });
    } else {
      this.onSelect({selected: []});
    }
  }

  public onSelect(event) {
    if(event.selected) {
      this.selected.splice(0, this.selected.length);
      this.selected.push(...event.selected);
      this.selected = [...this.selected]; // workaround to get the changes reflected on the datatable
      if(this.config.rowSelector.onSelect && typeof this.config.rowSelector.onSelect === 'function') {
        this.config.rowSelector.onSelect(this.selected);
      }
    }
    if (this.requestParams.pagination.count !== event.selected.length || !event.selected.length) {
      this.allSelected = false;
    }
  }

  public onActivate(event) {
    if(this.config.rowSelector.onActivate && typeof this.config.rowSelector.onActivate === 'function') {
      this.config.rowSelector.onActivate(event);
    }
  }

  public onButtonClickForSelector() {
    if(this.config.channelSelector.onSelect && typeof this.config.channelSelector.onSelect === 'function') {
      this.config.channelSelector.onSelect(this.selected);
      this.selected.splice(0, this.selected.length);
    }
  }

  public onButtonClickForExportation() {
    this.exportationModalService.showExportModal({
      channelId: this.datagridService.getChannelIdsOfPage()
    });
  }

  public onButtonClickForBulkEdit() {
    this.channelBulkUpdateModalService.showBulkUpdateModal({
      channelIds: this.datagridService.getChannelIdsOfPage(),
    });
  }

  public setConfigured() {
    this.bConfigured = true;
  }

  public toggleExpandRow(row) {
    this.dataTable.rowDetail.toggleExpandRow(row);
  }

  private updateProperty(obj, key, value) {
    const cellKeys: string[] = key.split('.');

    const subKey = cellKeys[0];

    if(cellKeys.length === 1) {
      obj[subKey] = value;
    } else {
      cellKeys.shift();
      this.updateProperty(obj[subKey], cellKeys.join('.'), value);
    }
  }

  public onChange(event, cell, rowIndex) {
    // Update property, and disable edit mode
    this.editing[`${rowIndex}-${cell}`] = false;

    const booleanTypes  = ['checkbox'];
    const value         = (booleanTypes.indexOf(event.target.type) !== -1) ? event.target.checked : event.target.value;

    this.updateProperty(this.rows[rowIndex], cell, value);

    // Call specific handler for change
    if(this.config.inlineEdit[cell] && this.config.inlineEdit[cell].onChange && typeof this.config.inlineEdit[cell].onChange === 'function') {
      this.config.inlineEdit[cell].onChange(this.rows[rowIndex]);
    }
  }

  public onDetailChange(event, cell, rowIndex, row) {
    this.detailEditing[`${rowIndex}-${cell}`] = false;

    const booleanTypes  = ['checkbox'];
    const value         = (booleanTypes.indexOf(event.target.type) !== -1) ? event.target.checked : event.target.value;

    let parentRow: Datagrid;
    for(const datagridRow of this.rows) {
      if(datagridRow.throughputs && datagridRow.throughputs.length > 0) {
        for(const throughput of datagridRow.throughputs) {
          if(throughput === row) {
            parentRow = datagridRow;
            break;
          }
        }
      }
    }

    if(parentRow) {
      this.updateProperty(parentRow.throughputs[rowIndex], cell, value);

      // Call specific handler for change
      if(
        this.config.inlineEdit[`throughput.${cell}`] &&
        this.config.inlineEdit[`throughput.${cell}`].onChange &&
        typeof this.config.inlineEdit[`throughput.${cell}`].onChange === 'function'
      ) {
        this.config.inlineEdit[`throughput.${cell}`].onChange(parentRow.throughputs[rowIndex]);
      }
    }
  }

  public inlineEditEnabled(key: string) {
    return (!this.viewMode && this.config.inlineEdit[key] && this.config.inlineEdit[key].enabled && this.config.inlineEdit[key].enabled === true);
  }

  public onDetailToggle(event) {

  }

  public getPageNumbers(rows: number, pageSize: number) {
    return Array(Math.ceil(rows / pageSize));
  }

  public onCurrentPageChange($event: any) {
    const pageNumber = parseInt($event.target.value, 10);
    if (!isNaN(pageNumber)) {
      this.requestParams.pagination.offset = (pageNumber - 1);
      this.fetchData();
    }
  }

  public getCurrentState(channelId: string): Observable<ChannelCurrentState> {
    return this.channelService.getCurrentState(channelId);
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/datagrid/datagrid-list.component.ts